/* istanbul ignore file */
export * from './SelectedFilterValueList';
